import { useFormContext } from 'react-hook-form';
import ServicesAutoComplete from './ServicesAutoComplete';
import type { CreateVisitType } from '../../visits/entity';
import { useServicesQuery } from '../queries';
import { Service } from '../entity';

export const ServiceSelect = ({ onChange }: { onChange?: (service: Service) => void }) => {
  const { control } = useFormContext<CreateVisitType>();
  const { data: services, isLoading } = useServicesQuery();

  return (
    <ServicesAutoComplete
      fieldPath="serviceIds"
      control={control}
      onChange={service => {
        if (!service) {
          return;
        }
        if (onChange) {
          const serviceItem = services?.find(s => s.id === service.id);
          if (serviceItem) {
            onChange(serviceItem);
          }
        }
      }}
      queryData={services}
      isLoading={isLoading}
    />
  );
};
